import Action from '../Action'
import './styles/ModalCreateService.css'
import { useState, useEffect } from 'react';
import LoadSimple from '../LoadSimple';
import InputAdmin from '../InputAdmin';
import { useFetch } from '../../hooks/useFetch';
import SelectorAdmin from '../SelectorAdmin';
import { lang } from "../generales/traduction";
import { capitalizeFirstLetter } from "../../utils/utils";
const ModalCreateService = ({ user, handleShowPopup, languaje, server, dataUsers, setRegisterIsValid, dataService, setData, loading, setLoading, setError, setEditActive, editActive, closCreateManttoModal }) => {
    const obtenerFechaActualLocal = () => {
        const ahora = new Date();
        const anio = ahora.getFullYear();
        const mes = String(ahora.getMonth() + 1).padStart(2, '0'); // El mes se cuenta desde 0
        const dia = String(ahora.getDate()).padStart(2, '0');
        const horas = String(ahora.getHours()).padStart(2, '0');
        const minutos = String(ahora.getMinutes()).padStart(2, '0');

        return `${anio}-${mes}-${dia}T${horas}:${minutos}`;
    };
    const dataCriticalities = useFetch('cassia/criticalities', '', '', 'GET', server)
    const [loadingM, setLoadingM] = useState(false);
    const [IpValid, setIpValid] = useState(true)
    const [matchPassword, setMatchPassword] = useState(false)
    const [disabled, setDisabled] = useState(true)
    const [host, sethost] = useState([])
    // console.log(devices.data.hosts.find(obj => obj.hostid === dataService.hostid))

    const [ManttoData, setManttoData] = useState({ service_name: (editActive) ? dataService.service_name : "", cassia_criticality_id: (editActive) ? dataService.cassia_criticality_id : 0, description: (editActive) ? dataService.description : "" })
    const [hostName, setHostName] = useState("")
    const [hostLocation, setHostLocation] = useState("")
    const [hostActivate, setHostActivate] = useState(0)

    // const tec_list=useFetch('cassia/ci_elements/technologies','','','GET',server)
    const [msgError, setMsgError] = useState("")
    const [listSearchIP, setListSearchIP] = useState(false)

    const servicesActual = dataUsers.data.map(obj => obj.service_name);

    useEffect(() => {
        //    console.log("cambio host")
        if (host.length >= 1) {

            setHostName(host[0].name)

        } else {

            setHostName("")

        }
    }, [host])

    const handleChange = (e) => {

        const { name, value } = e.target
        if (e.target.name === "service_name") {
            if (servicesActual.includes(value)) {
                if (editActive && value == dataService.service_name) {
                    setIpValid(true)
                } else {

                    setDisabled(true)
                    setIpValid(false)
                    setMsgError(capitalizeFirstLetter(lang[languaje]['msgServicioExiste']))

                }

            } else {
                // setDisabled(true)
                setIpValid(true)
                // console.log("no existe")
            }
            setManttoData((prevState) => {
                return {
                    ...prevState,
                    [name]: value
                }

            })
        }
        if (e.target.name === "criticality") {
            setManttoData((prevState) => {
                return {
                    ...prevState,
                    [name]: value === "" ? 0 : (parseInt(value))
                }

            })
        } else if (e.target.name === "status") {
            setManttoData((prevState) => {
                return {
                    ...prevState,
                    [name]: (value == "Inactivo") ? capitalizeFirstLetter(lang[languaje]['activo']) : capitalizeFirstLetter(lang[languaje]['inactivo'])
                }

            })
        } else {
            setManttoData((prevState) => {
                return {
                    ...prevState,
                    [name]: value
                }

            })
        }



        if (e.target.name === "ip") {
            if (value == "") {
                setHostLocation("")
                setHostActivate(0)
                setIpValid(true)
                sethost([])
                setHostName("")
                setHostLocation("")
            } else {
                setIpValid(validateIp(value))
            }


        }



    }

    useEffect(() => {

        if ((ManttoData.service_name == "" || IpValid == false)) {

            setDisabled(true)
        } else {

            setDisabled(false)
        }
    }, [ManttoData])


    const Registrar = () => {

        let method = 'POST'
        let url_add = ''

        if (editActive) {
            method = 'PUT'
            url_add = '/' + dataService.cassia_tech_service_id

        }

        setLoading(true)
        const fetchDataPost = async () => {

            try {

                const response = await fetch(server.url + '/api/v1/cassia/services' + url_add, {
                    method: method,
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                    },
                    body: JSON.stringify(ManttoData),
                });

                if (response.ok) {

                    const data1 = await response.json();
                    setLoading(false)
                    // Manejo de la respuesta
                    setData(data1)
                    handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']), capitalizeFirstLetter(((editActive) ? lang[languaje]['regEditCorr'] : lang[languaje]['regGenCorr'])), '', true)
                    // console.log(data1);
                    closCreateManttoModal()
                    setRegisterIsValid(true)

                    const timer = setTimeout(() => {
                        setRegisterIsValid(false)
                        setEditActive(false)
                        closCreateManttoModal()
                    }, 3000);

                } else {
                    const data1 = await response.json();
                    handleShowPopup('Error!!!', capitalizeFirstLetter(lang[languaje]['regNoGenCorr']), data1.detail, false)

                    throw new Error('Error en la solicitud');
                }
            } catch (error) {
                setHostName("")
                setManttoData({ ip: "", host_id: 0, date: "", responsible_name: "", auth_name: "", device_description: "", justification: "", previous_state: "", new_state: "", impact: "", result: "", observations: "", files: [], status: 'Activo' })
                handleShowPopup('Error!!!', capitalizeFirstLetter(lang[languaje]['regNoGenCorr']), capitalizeFirstLetter(lang[languaje]['reportError']), false)
                setLoading(false)
                // Manejo de errores
                setError(error)
                closCreateManttoModal()
                setRegisterIsValid(true)

                const timer = setTimeout(() => {
                    setRegisterIsValid(false)
                    setEditActive(false)
                    closCreateManttoModal()
                }, 3000);
                console.error(error);
            }
        };

        fetchDataPost();

    }

    const buscar_host = (ip) => {

        setLoadingM(true)
        const fetchDataPost = async () => {

            try {

                const response = await fetch(server.url + '/api/v1/cassia/ci_elements/search_host/' + ip, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'accept': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
                    },
                });
                //   console.log(response)
                if (response.ok) {

                    const data1 = await response.json();
                    setLoadingM(false)
                    if (data1.data.length == 0) {
                        sethost([])
                        setHostName("")
                        setHostLocation("")
                        setHostActivate(0)
                        setMsgError(lang[languaje]['msgIpNoExiste'])
                        setIpValid(false)
                    } else {
                        setIpValid(true)

                    }
                    sethost(data1.data)
                    setDisabled(true)
                } else {
                    const data1 = await response.json();
                    throw new Error('Error en la solicitud');
                }
            } catch (error) {
                console.error(error);
            }
        };

        fetchDataPost();

    }
    const changeOption = (option, index) => {
        setManttoData((prevState) => {
            return {
                ...prevState,
                ['cassia_criticality_id']: option.value === "" ? 0 : (parseInt(option.value))
            }

        })
        // setManttoRelation(option.value)
    }

    const validateIp = (ip) => {

        const ipRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
        let result = ipRegex.test(ip);
        if (result) {
            buscar_host(ip)
        } else {
            setHostLocation("")
            setMsgError(lang[languaje]['ipNoValida'])
            sethost([])
            setHostName("")
            setHostLocation("")
            setHostActivate(0)
        }
        return result;
    };



    const closeListSearch = () => {
        setListSearchIP(false)
    }
    const { service_name, cassia_criticality_id, description } = ManttoData;
    return (
        <div className="modal-GS-content">
            <div className='card-modal-gs modal-verificate'>
                <div className='head-card-modal-gs'>
                    <div className='title-head-card-modal-gs'>
                        {((editActive) ? lang[languaje]['editar'].toUpperCase() : lang[languaje]['crear'].toUpperCase()) + ' ' + lang[languaje]['servicio'].toUpperCase()}
                    </div>
                </div>
                <div className='content-card-modal-gs' style={{ overflowY: 'scroll', scrollbarWidth: 'thin' }}>

                    <div className="form-GS-box">

                        <div className="user-box-GS" style={{ height: '25%' }}>

                            <label className='label-GS'>{capitalizeFirstLetter(lang[languaje]['nombreServicio'])}</label>
                            <input required name="service_name" placeholder={capitalizeFirstLetter(lang[languaje]['nombreServicio'])} type="text" value={service_name}
                                onChange={handleChange} />


                            {
                                IpValid ? '' : <span className='form-msg-error-gs'> {msgError}</span>
                            }

                        </div>


                        <div className="user-box-GS" style={{ height: '25%' }}>

                            <label className='label-GS'>{capitalizeFirstLetter(lang[languaje]['severidad'])}</label>
                            {
                                (dataCriticalities.loading) ? '. . .' :
                                    <SelectorAdmin languaje={languaje} placeholder={'Seleccionar agencia...'} opGeneral={true} txtOpGen={'N/A'} opt_de={cassia_criticality_id} origen={'Admin'} data={dataCriticalities.data.data} loading={dataCriticalities.loading} titulo='Severity' selectFunction={changeOption} index={0}></SelectorAdmin>

                            }
                            {
                                // (name==="" || nombreIsValid)?'':<span className='form-msg-error'> Nombre no valido</span>
                            }

                        </div>

                        <div className="user-box-GS" style={{ height: '25%' }}>
                            <label className='label-GS'>{capitalizeFirstLetter(lang[languaje]['descripcion'])}</label>
                            <input required name="description" placeholder={capitalizeFirstLetter(lang[languaje]['descripcion'])} type="text" value={description}
                                onChange={handleChange} />
                            {
                                // (name==="" || nombreIsValid)?'':<span className='form-msg-error'> Nombre no valido</span>
                            }

                        </div>



                        <div className="user-box-GS" style={{ height: '25%' }}>
                            {
                                (loading) ? <LoadSimple></LoadSimple>
                                    :
                                    <>
                                        <Action disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])} action={closCreateManttoModal} />
                                        <Action disabled={disabled} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['guardar'])} action={Registrar} />
                                    </>
                            }

                            {
                                // (registerIsValid && data.message!=="User deleted successfully")?<span className='form-msg-ok'>Usuario registrado correctamente</span>:''
                            }

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalCreateService